import { render, staticRenderFns } from "./FirmaTanimliAlanlarButtons.vue?vue&type=template&id=715a944e&"
import script from "./FirmaTanimliAlanlarButtons.vue?vue&type=script&lang=js&"
export * from "./FirmaTanimliAlanlarButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports